import useOnBackButtonPressed from '@hooks/native/useOnBackButtonPressed';
import { useActivity, useFlow } from '@stackflow/react';
import { isForceUpdatingAtom, isSidebarOpenAtom } from '@states/uiAtoms';
import { useAtom, useAtomValue } from 'jotai';

function useAndroidBackButton() {
    const { pop, push } = useFlow();
    const [isSidebarOpen, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
    const isForceUpdating = useAtomValue(isForceUpdatingAtom);
    const { isTop } = useActivity();

    useOnBackButtonPressed({
        deps: [isSidebarOpen, isTop],
        callbackFn: () => {
            // 강제 업데이트 중 뒤로가기 방지
            if (isForceUpdating) {
                return;
            }
            if (isTop) {
                if (isSidebarOpen) {
                    setIsSidebarOpen(false);
                } else {
                    push('AppTerminationModal', {});
                }
            } else {
                pop();
            }
        },
    });
}

export default useAndroidBackButton;
